module.exports = __webpack_public_path__ + "img/chang-tien-wei-5.9a3ab8b3.jpg";